export default __webpack_public_path__ + "static/media/audioWave.4ad16477.gif";